import { useState, useEffect } from "react";
import { PacienteAdminCreate } from "./PacienteAdminCreate";
import { useLoaderData, useParams } from "react-router-dom";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import es from "react-phone-input-2/lang/es.json";

import * as APIPACIENTE from "../services/pacientes";

export function PacienteAdminNew() {

  function generatePassword(length = 12) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()';
    let password = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      password += characters[randomIndex];
    }
    return password;
  }

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);


  // Set default valor for today date
  const todayDate = new Date()
    .toISOString()
    .replace(/T.*/, "")
    .split("-")
    .join("-");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [sexoPacie, setSexoPacie] = useState("");
  const [direccion, setDireccion] = useState("");
  const [direccionNum, setDireccionNum] = useState("");
  const [direccionPiso, setDireccionPiso] = useState("");
  const [direccionCiudad, setDireccionCiudad] = useState("");
  const [direccionProvincia, setDireccionProvincia] = useState("");
  const [direccionCp, setDireccionCp] = useState("");
  const [email, setEmail] = useState("");
  const [telefono, setTelefono] = useState("");
  const [dni, setDni] = useState("");
  const [nacimiento, setNacimiento] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [hceMin, setHceMin] = useState("");
  const [hce, setHce] = useState("");
  const [nombreFamiliar, setNombreFamiliar] = useState("");
  const [telefonoFamiliar, setTelefonoFamiliar] = useState("");
  const [estadoUsuario, setEstadoUsuario] = useState('activo');

  // Load Last HCE number assigned
  useEffect(() => {
      const newPassword = generatePassword();
      setPassword(newPassword);

      const loadHceNumber = async () => {
      // Await make wait until that
      // promise settles and return its result
      const response = await APIPACIENTE.getLastPacientes();
      console.log(response);

      const lastHceNumbers = response.map((field) => field.meta.hce);
      console.log(lastHceNumbers);

      const lastHce = Math.max(...lastHceNumbers);
      console.log(lastHce);

      let currentHce = lastHce + 1;
      console.log(currentHce);
      // After fetching data stored it in posts state.
      setHceMin(currentHce);
      setHce(currentHce);
    };

    // Call the function
    loadHceNumber();
  }, []);

  const submitPacienteAdmin = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    console.log(
      firstName,
      lastName,
      sexoPacie,
      direccion,
      direccionNum,
      direccionPiso,
      direccionCiudad,
      direccionProvincia,
      direccionCp,
      email,
      telefono,
      dni,
      nacimiento,
      hce,
      nombreFamiliar,
      telefonoFamiliar,
      estadoUsuario,
      username,
      password
    );
    try {
      await PacienteAdminCreate(
        firstName,
        lastName,
        sexoPacie,
        direccion,
        direccionNum,
        direccionPiso,
        direccionCiudad,
        direccionProvincia,
        direccionCp,
        email,
        telefono,
        dni,
        nacimiento,
        hce,
        nombreFamiliar,
        telefonoFamiliar,
        estadoUsuario,
        username,
        password
      ).then(
        (val) => {
          window.location.replace(`../pacientes/${val.id}`);
          console.log(val);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id='content'>
        <form id='formNewElement' onSubmit={submitPacienteAdmin}>
          <h3>Crear Paciente</h3>
          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='firstName'>Nombre</label>
              <div className='control'>
                <input
                  className='input'
                  id='firstName'
                  required
                  type='text'
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='lastName'>Apellidos</label>
              <div className='control'>
                <input
                  className='input'
                  id='lastName'
                  required
                  type='text'
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='sexoPacie'>Sexo</label>
              <div className='select'>
                <select
                  className='select'
                  id='sexoPacie'
                  required
                  name='sexoPacie'
                  defaultValue=''
                  onChange={(e) => setSexoPacie(e.target.value)}
                >
                  <option disabled value=''>-- Selecciona una opción --</option>
                  <option value='hombre'>Hombre</option>
                  <option value='mujer'>Mujer</option>
                </select>
              </div>
            </div>
            <div className='field'>
              <label htmlFor='direccion'>Dirección</label>
              <div className='control'>
                <input
                  className='input'
                  id='direccion'
                  type='text'
                  value={direccion}
                  onChange={(e) => setDireccion(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='direccionNum'>Número</label>
              <div className='control'>
                <input
                  className='input'
                  id='direccionNum'
                  type='text'
                  value={direccionNum}
                  onChange={(e) => setDireccionNum(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='direccionPiso'>Piso</label>
              <div className='control'>
                <input
                  className='input'
                  id='direccionPiso'
                  type='text'
                  value={direccionPiso}
                  onChange={(e) => setDireccionPiso(e.target.value)}
                />
              </div>
            </div>

            <div className='field'>
              <label htmlFor='direccionCiudad'>Población</label>
              <div className='control'>
                <input
                  className='input'
                  id='direccionCiudad'
                  type='text'
                  value={direccionCiudad}
                  onChange={(e) => setDireccionCiudad(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='direccionProvincia'>Provincia</label>
              <div className='control'>
                <input
                  className='input'
                  id='direccionProvincia'
                  type='text'
                  value={direccionProvincia}
                  onChange={(e) => setDireccionProvincia(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='direccionCp'>Código postal</label>
              <div className='control'>
                <input
                  className='input'
                  id='direccionCp'
                  type='text'
                  value={direccionCp}
                  onChange={(e) => setDireccionCp(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='email'>Email</label>
              <div className='control'>
                <input
                  className='input'
                  id='email'
                  required
                  type='email'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            <div className='field'>
              <label htmlFor='telefono'>Teléfono Móvil</label>
              <div className='control'>
                <PhoneInput
                  inputProps={{
                    className: "input",
                    name: "telefono",
                    required: true,
                    id: "telefono",
                  }}
                  placeholder='+34 658 309 174'
                  localization={es}
                  value={telefono}
                  country={"es"}
                  onChange={(value) => setTelefono(value)}
                />
              </div>
            </div>
          </div>

          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='dni'>NIF/Pasaporte</label>
              <div className='control'>
                <input
                  className='input'
                  id='dni'
                  required
                  type='text'
                  value={dni}
                  onChange={(e) => setDni(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='nacimiento'>Fecha de nacimiento</label>
              <div className='control'>
                <input
                  className='input'
                  id='nacimiento'
                  required
                  type='date'
                  value={nacimiento}
                  onChange={(e) => setNacimiento(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='username'>Nombre de usuario</label>
              <div className='control'>
                <input
                  className='input'
                  id='username'
                  required
                  readOnly
                  type='text'
                  value={email}
                  disabled
                  // onChange={(e) => setUsername(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='password'>Contraseña</label>
              <div className='control'>
                <input
                  className='input'
                  id='password'
                  required
                  type='text'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='username'>NHC</label>
              <div className='control'>
                <input
                  className='input'
                  id='username'
                  required
                  type='number'
                  value={hce}
                  min={hceMin}
                  onChange={(e) => setHce(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='nombreFamiliar'>Nombre de familiar</label>
              <div className='control'>
                <input
                  className='input'
                  id='nombreFamiliar'
                  type='text'
                  value={nombreFamiliar}
                  onChange={(e) => setNombreFamiliar(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='telefonoFamiliar'>
                Número de teléfono de familiar
              </label>
              <div className='control'>
                <PhoneInput
                  inputProps={{
                    className: "input",
                    name: "telefonoFamiliar",
                    required: true,
                    id: "telefonoFamiliar",
                  }}
                  placeholder='+34 658 309 174'
                  localization={es}
                  value={telefonoFamiliar}
                  country={"es"}
                  onChange={(value) => setTelefonoFamiliar(value)}
                />
              </div>
            </div>
          </div>

          <div className='grid--2col'>
            <div className="field">
              <label htmlFor="estadoUsuario">Estado del usuario</label>
              <div className="control">
                <div className="select">
                  <select
                    className="select"
                    id="estadoUsuario"
                    required
                    name="estadoUsuario"
                    value={estadoUsuario}
                    onChange={(e) => setEstadoUsuario(e.target.value)}
                  >
                    <option disabled value="">-- Selecciona una opción --</option>
                    <option value="activo">Activo</option>
                    <option value="inactivo">Inactivo</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

        </form>
      </div>
      <div id='actions'>
        <button 
        className='button is-link' 
        form='formNewElement' 
        type='submit'
        disabled={isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : 'Guardar' }
        </button>
      </div>
    </>
  );
}
